import { PersonFilledIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

type OtherPatronsRowProps = {
  label: string;
};

export const OtherPatronsRow = ({ label }: OtherPatronsRowProps) => (
  <HStack alignItems="center" gap={3} paddingVertical={2}>
    <Box
      backgroundColor="surface-secondary"
      height={24}
      width={24}
      justifyContent="center"
      alignItems="center"
      borderRadius="2"
    >
      <PersonFilledIcon />
    </Box>
    <Text variant="mainBaseSemiBold">{label}</Text>
  </HStack>
);
